import React, { useState } from 'react';
import { Box, Button, Card, FormControl, FormLabel, TextField, Typography } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../Context/AuthContext';

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

export default function ResetPassword() {
    const query = useQuery();
    const navigate = useNavigate();
    const { ResetPassword } = useAuth();

    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');

    const email = query.get('email');
    const token = query.get('token');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setSuccess('');

        if (!password || password.length < 6) {
            setError('Password must be at least 6 characters.');
            return;
        }
        if (password !== confirmPassword) {
            setError('Passwords do not match.');
            return;
        }

        const result = await ResetPassword(email, password, confirmPassword, token);

        if (result) {
            setSuccess('Password reset successful! Redirecting to login...');
            setTimeout(() => navigate('/sign-in'), 3000);
        } else {
            setError(result?.message || 'Reset failed. Please try again.');
        }
    };

    return (
        <Box sx={{ display: 'flex', justifyContent: 'center', px: 2, py: { xs: 6, sm: 10 } }}>
            <Card variant="outlined" sx={{ p: 4, maxWidth: 450, width: '100%', borderRadius: 3 }}>
                <Typography variant="h4" gutterBottom sx={{ fontWeight: 700 }}>
                    Reset Your Password
                </Typography>
                <form onSubmit={handleSubmit}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                        <Typography variant="body2" color="text.secondary">Resetting password for: {email}</Typography>
                    <FormControl>
                        <FormLabel htmlFor="password">New Password</FormLabel>
                        <TextField
                            id="password"
                            type="password"
                            required
                            fullWidth
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                    </FormControl>
                    <FormControl>
                        <FormLabel htmlFor="confirmPassword">Confirm Password</FormLabel>
                        <TextField
                            id="confirmPassword"
                            type="password"
                            required
                            fullWidth
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                        />
                    </FormControl>

                    {error && (
                        <Typography variant="body2" color="error">
                            {error}
                        </Typography>
                    )}
                    {success && (
                        <Typography variant="body2" color="primary">
                            {success}
                        </Typography>
                    )}

                        <Button type="submit" variant="contained" fullWidth>
                            Reset Password
                        </Button>
                    </Box>
                </form>
            </Card>
        </Box>
    );
}
